import ShowroomSetupButton from "./showroom-setup-button";

export default ShowroomSetupButton;